angular.module('impactx.search').directive('ixAttributeSearchGuidedAttribute', function () {
    return {
        restrict: 'E',
        scope: {
            facetResult: "=",
            drillDownCallback: "&",
            useSearchFilterFactoryForDrilldown: "="
        },
        controller: function($scope, SearchFilter, searchFilter) {
            $scope.exists = SearchFilter.existsDrillDown;
            $scope.toggleDrillDown = function(item) {
                SearchFilter.toggleDrillDown(item);
                if ($scope.useSearchFilterFactoryForDrilldown) {
                    searchFilter.toggleDrillDown(item);
                }
                $scope.drillDownCallback();
            }
        },
        templateUrl: 'modules/search/templates/attributesearch.guidedattribute.html'
    }
});